import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const CheckoutPage = () => {
  const { txnid } = useParams(); // URL se txnid le lo
  const [paymentToken, setPaymentToken] = useState("");
  const [amount, setAmount] = useState(0); 
  const [success_url, setsuccess_url] = useState(0); 
  const [failed_url, setfailed_url] = useState(0); 
  const [accessKey, setAccessKey] = useState("6beb5cdb-2f24-4263-9536-5b842aab728c"); // sandbox key
  const [loading, setLoading] = useState(true);

  // ✅ Step 1: Load Layer.js script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    // script.src = "https://sandbox-payments.open.money/layer";
    script.src = "https://payments.open.money/layer";
    script.async = true;

    script.onload = () => console.log("✅ Layer.js loaded successfully");
    script.onerror = () => console.error("❌ Failed to load Layer.js");

    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  // ✅ Step 2: Fetch payment token from backend using txnid
  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await authFetch(`/api/v1/report/get_txn_check/${txnid}`);
        const data = await res.json();
        console.log("API Response:", data);

        if (data.status === "success" && data.data?.refno) {
          setPaymentToken(data.data.refno);
          setAmount(data.data.amount || 0);
          setsuccess_url(data.data.success);
          setfailed_url(data.data.failed);
        } else {
          alert("Invalid transaction or token not found.");
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Failed to fetch payment details.");
      } finally {
        setLoading(false);
      }
    };

    if (txnid) fetchToken();
  }, [txnid]);

  // ✅ Step 3: Handle Layer payment popup
  const handlePayment = () => {
    if (!paymentToken) {
      alert("Payment token not loaded yet.");
      return;
    }
    if (!window.Layer || !window.Layer.checkout) {
      alert("Layer.js not loaded yet. Try again in 2 seconds.");
      return;
    }

    window.Layer.checkout(
      {
        token: paymentToken,
        accesskey: accessKey,
        theme: {
          logo: "https://suvidhaabnk.com/images/logo1.png",
          color: "#3d9080",
          error_color: "#ff2b2b",
        },
      },
      (response) => {
        console.log("🟢 Layer Response:", response);

        if (response.status === "captured") {
          alert("✅ Payment captured successfully!");
          // window.location.href = "/success";
          if (success_url && success_url.startsWith("http")) {
            window.location.href = success_url;
          } else {
            window.location.href = "/success";
          }
        } else if (response.status === "failed") {
          alert("❌ Payment failed!");
          // window.location.href = "/failed";
          if (failed_url && failed_url.startsWith("http")) {
            window.location.href = failed_url;
          } else {
            window.location.href = "/failed";
          }
        } else if (response.status === "cancelled") {
          alert("⚠️ Payment cancelled!");
          // window.location.href = "/failed";
          // window.location.href = "/cancelled";
          if (failed_url && failed_url.startsWith("http")) {
            window.location.href = failed_url;
          } else {
            window.location.href = "/failed";
          }
        }
      },
      (err) => {
        console.error("❌ Integration Error:", err);
      }
    );
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h3>Loading payment details...</h3>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        fontFamily: "sans-serif",
      }}
    >
      <h2>Suvidhape Checkout</h2>
      <p>Transaction ID: {txnid}</p>
      <p>Click below to pay ₹{amount.toFixed(2)} using Suvidhape </p>
      <button
        onClick={handlePayment}
        style={{
          backgroundColor: "#3d9080",
          color: "#fff",
          border: "none",
          padding: "12px 24px",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Pay ₹{amount.toFixed(2)}
      </button>
    </div>
  );
};

export default CheckoutPage;
